/* eslint-disable react/jsx-indent */
import React from 'react';
import styled from 'styled-components';
import { SortOrder } from 'antd/lib/table/interface';
import DownAngle from '../../../../assets/img/icons/DownAngle.svg';

interface ITableSorting {
    sortOrder: SortOrder
}

const StyledWrapper = styled.div<ITableSorting>`
    width: 20px;
    padding-left:5px;
    display:inline-block;
  .sort_asc {
    transform: rotate(180deg);
    display: inline-grid;
    padding-bottom: 4px;
    opacity: ${({ sortOrder }) => (sortOrder !== 'ascend' ? '50%' : '100%')};
  }
  .sort_dsc {
    opacity: ${({ sortOrder }) => (sortOrder !== 'descend' ? '50%' : '100%')};
  }
 .icon-sort, .sort {
    width: 8px; 
    height: 8px;
    display: block;
 }
 .sort {
    margin-bottom: 2px;
 }
`;
const TableSorting = (props: ITableSorting) => {
    const { sortOrder } = props;
    return (
        <StyledWrapper sortOrder={sortOrder}>
            <span className="sort sort_asc">
                <img src={DownAngle} alt="Sort Asc" className="icon-sort" />
            </span>
            <span className="sort sort_dsc">
                <img src={DownAngle} alt="Sort Asc" className="icon-sort" />
            </span>
        </StyledWrapper>
    );
};

export default TableSorting;
